module.exports = __webpack_public_path__ + "img/icon-22-green.221142a6.svg";